import { z } from 'zod/v4';

export const PASSWORD_MIN_LENGTH = 12;
const SPECIAL_CHAR_REGEX = /[^a-zA-Z0-9]/;

export interface PasswordValidationResult {
    isValid: boolean;
    errors: string[];
}

export function validatePassword(password: string): PasswordValidationResult {
    const errors: string[] = [];

    if (password.length < PASSWORD_MIN_LENGTH) {
        errors.push(`Password must be at least ${PASSWORD_MIN_LENGTH} characters.`);
    }
    if (!/[a-z]/.test(password)) {
        errors.push('Password must contain a lowercase letter.');
    }
    if (!/[A-Z]/.test(password)) {
        errors.push('Password must contain an uppercase letter.');
    }
    if (!/[0-9]/.test(password)) {
        errors.push('Password must contain a number.');
    }
    if (!SPECIAL_CHAR_REGEX.test(password)) {
        errors.push('Password must contain a special character.');
    }

    return { isValid: errors.length === 0, errors };
}

export const passwordSchema = z
    .string()
    .min(PASSWORD_MIN_LENGTH, `Password must be at least ${PASSWORD_MIN_LENGTH} characters.`)
    .regex(/[a-z]/, 'Password must contain a lowercase letter.')
    .regex(/[A-Z]/, 'Password must contain an uppercase letter.')
    .regex(/[0-9]/, 'Password must contain a number.')
    .regex(SPECIAL_CHAR_REGEX, 'Password must contain a special character.');
